import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../../../Components/base/sidebar';
import ActionBar from '../../../Components/Button/ActionBar';
import SEOForm from '../../../Components/Forms/SEOForm';
import Delete from '../../../Components/Button/Delete';
import StoryDetails from '../../../Components/Forms/StoryDetails';
import BuyLinkForm from '../../../Components/Forms/BuyLinkForm';
import { toast } from 'sonner';

interface Item {
    ticket_id: number;
    ticket_group_code: string;
    // Add more properties as per your item structure
}

export default function TicketPricesEditor() {
    const location = useLocation();
    const id = location.state && location.state.id;
    const ticketGroupCode = location.state && location.state.ticketGroupCode;
    const [button_name, setButtonName] = useState('');
    const [url, setUrl] = useState('');
    const [ticket_group_code, setTicketGroupCode] = useState('');
    const [items, setItems] = useState<Item[]>([]);
    const [item, setItem] = useState<any | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [role, setRole] = useState<string | null>(null);
    // React state
    const [heading, setHeading] = useState<string[]>(['Ticket Selling 1']);
    const [tickets, setTickets] = useState<any[]>([]);

    useEffect(() => {
        if (id) {
            fetchItem(id);
        }
    }, [id]);

    const handleTicketGroupCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTicketGroupCode(e.target.value);
    };

    const handleButtonNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setButtonName(e.target.value);
    };

    const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUrl(e.target.value);
    };

    const navigate = useNavigate();

    const fetchItems = async () => {
        try {
            const response = await axios.get('https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                }
            });
            setItems(response.data.ticket)
        } catch (error) {
            console.error('Error Fetching items:', error);
        }
    };

    useEffect(() => {
        fetchItems();
    }, []);

    useEffect(() => {
        if (ticketGroupCode) {
            fetchTicketGroups(ticketGroupCode);
        }
    }, [ticketGroupCode]);


    const fetchTicketGroups = async (ticketGroupCode: string) => {
        try {
            const response = await axios.get(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/buy-link/group/${ticketGroupCode}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                }
            });

            console.log("API Response:", response.data);

            // Try all common formats
            const fetched = Array.isArray(response.data)
                ? response.data
                : response.data.tickets || response.data.ticket || [];

            if (!Array.isArray(fetched)) {
                console.error("Expected an array of tickets, got:", fetched);
                return;
            }

            const normalized = fetched.map(ticket => ({
                ...ticket,
                link_buttons: ticket.link_buttons || [{ button_name: '', url: '' }]
            }));

            setTicketGroupCode(ticketGroupCode);
            setTickets(normalized);

            const uniqueHeadings = normalized.map((t: any, i: number) => `Ticket Selling ${i + 1}`);
            setHeading(uniqueHeadings);

        } catch (error) {
            console.error('Error fetching ticket groups:', error);
        }
    };

    const fetchItem = async (id: number) => {
        try {
            const response = await axios.get(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/buy-link/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                }
            }); // Fetch item based on ID
            const ticket = response.data.ticket;
            if (ticket) {
                const { button_name, url, ticket_group_code, ticket_id } = ticket;
                setItem(ticket);
                setButtonName(button_name);
                setUrl(url);
                setTicketGroupCode(ticket_group_code);
            }
        } catch (error) {
            console.error('Error fetching item:', error);
        }
    };

    // const handleSubmit = async (e: React.FormEvent) => {
    //     e.preventDefault();
    //     setIsSubmitting(true);

    //     const formData = new FormData();
    //     formData.append('ticket_group_code', ticket_group_code);
    //     formData.append('button_name', button_name);
    //     formData.append('url', url);
    //     try {
    //         const authToken = localStorage.getItem('authToken');
    //         if (!authToken) {
    //             // Handle the case where authToken is not available
    //             alert('Authentication token not found!');
    //             setIsSubmitting(false);
    //             return;
    //         }

    //         await axios.post(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/buy-link/${id}`, formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //                 Authorization: `Bearer ${authToken}`,
    //             }
    //         });

    //         toast.success(<p className="text-[16px]">Content was submitted successfully!</p>, {
    //             duration: 1500,
    //         });
            
    //         setTimeout(() => {
    //             navigate('/view/post/buy-links');
    //         }, 1600);
    //     } catch (error) {
    //         console.error('There was an error submitting the form!', error);
    //         alert(`There was an error submitting the form!, ${error}`);
    //         // Handle error (e.g., show an error message)
    //     } finally {
    //         setTimeout(() => {
    //             setIsSubmitting(false);
    //         }, 3000);
    //     }
    // };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (!ticket_group_code) {
            toast.error("Please select a Ticket Group Code.");
            setIsSubmitting(false);
            return;
        }

        const formData = new FormData();
        formData.append('ticket_group_code', ticket_group_code);

        // Loop through tickets to append individual fields
        tickets.forEach((ticket, ticketIndex) => {
            formData.append('title[]', ticket.title || '');
            formData.append('start_date[]', ticket.start_date || '');
            formData.append('start_time[]', ticket.start_time || '');
            formData.append('end_date[]', ticket.end_date || '');
            formData.append('end_time[]', ticket.end_time || '');
            formData.append('description[]', ticket.description || '');
            formData.append('is_exclusive[]', ticket.is_exclusive ? '1' : '0');

            (ticket.link_buttons || []).forEach((button: { button_name: string; url: string }, btnIndex: number) => {
                formData.append(`button_name[${ticketIndex}][]`, button.button_name || '');
                formData.append(`url[${ticketIndex}][]`, button.url || '');
            });
        });

        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                toast.error("Authentication token not found.");
                setIsSubmitting(false);
                return;
            }

            await axios.post(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/buy-link/${ticket_group_code}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                }
            });

            toast.success(<p className="text-[16px]">Content was submitted successfully!</p>, {
                duration: 1500,
            });

            setTimeout(() => {
                navigate('/view/post/buy-links');
            }, 1600);
        } catch (error) {
            console.error('Error updating the form:', error);
            toast.error(<p className="text-[16px]">There was an error submitting the form!</p>, {
                duration: 2000,
            });
        } finally {
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        }
    };

    const handleDelete = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            if (!authToken) {
                alert('Authentication token not found!');
                return;
            }

            const confirmDelete = window.confirm('Are you sure you want to delete this content?');
            if (!confirmDelete) {
                return; // If user cancels, do nothing
            }

            if (id) {
                await axios.delete(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/buy-link/${id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    }
                })
            };
            alert('Content Deleted Successfully !!');
            navigate('/view/post/buy-link');
        } catch (error) {
            console.error('There was an error deleting the content!', error);
            alert(`There was an error deleting the content!, ${error}`);
        }
    };

    useEffect(() => {
        const storedRole = localStorage.getItem('role');
        setRole(storedRole);
    }, []);

    const handleViewShortstory = () => {
        window.open(`https://pulpmagazine.com/article/${id}`, '_blank');
    };

    const handleTicketFieldChange = (ticketIndex: number, field: string, value: any) => {
        const updated = [...tickets];
        updated[ticketIndex][field] = value;
        setTickets(updated);
    };

    const handleButtonChange = (
        ticketIndex: number,
        buttonIndex: number,
        field: string,
        value: string
    ) => {
        const updated = [...tickets];
        if (!updated[ticketIndex].link_buttons) {
            updated[ticketIndex].link_buttons = [];
        }
        if (!updated[ticketIndex].link_buttons[buttonIndex]) {
            updated[ticketIndex].link_buttons[buttonIndex] = { button_name: '', url: '' };
        }
        updated[ticketIndex].link_buttons[buttonIndex][field] = value;
        setTickets(updated);
    };

    const handleAddNewTicket = () => {
        const newTicket = {
            title: '',
            description: '',
            start_date: '',
            start_time: '',
            end_date: '',
            end_time: '',
            is_exclusive: 0,
            link_buttons: [{ button_name: '', url: '' }],
        };
        setTickets([...tickets, newTicket]);
        setHeading([...heading, `Ticket Selling ${heading.length + 1}`]);
    };

    return (
        <>
            <div className="w-full p-5">
                <div className="flex justify-between items-center mb-4">
                    <h1 className="GraphikSemibold text-[20px] font-semibold">Edit Buy Link</h1>
                    <ActionBar
                        role={role}
                        onSubmit={handleSubmit}
                        onView={handleViewShortstory}
                        isSubmitting={isSubmitting}
                        isSaved={isSubmitting}
                    />
                </div>

                <div className="py-5 px-4 rounded bg-white">
                    {items.length > 0 && tickets && (
                        <BuyLinkForm
                            ticket_group_code={ticket_group_code}
                            items={items}
                            tickets={tickets}
                            onTicketGroupCodeChange={handleTicketGroupCodeChange}
                            onChange={handleTicketFieldChange}
                            onButtonChange={handleButtonChange}
                            onAddNewTicket={handleAddNewTicket}
                            heading={heading}
                        />
                    )}
                </div>
            </div>
        </>
    );
}
